import { render, staticRenderFns } from "./OrderRegisterTypeSelect.vue?vue&type=template&id=6bf50ec7&"
import script from "./OrderRegisterTypeSelect.vue?vue&type=script&lang=ts&"
export * from "./OrderRegisterTypeSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports